
export default function (param) {

}
